import axios from 'axios';

const BASE_URL = import.meta.env?.VITE_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;

const uploadService = {
  // Make sure this name matches exactly what you call in the modal
  uploadFile: async (folder, file) => {
    const formData = new FormData();
    formData.append('folder', folder);
    formData.append('file', file);

    try {
      const response = await axios.post(`${BASE_URL}/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data; // Should return { success: true, url: "..." }
    } catch (error) {
      console.error("Upload Service Error:", error);
      throw error.response?.data || "File upload failed";
    }
  }
};

export default uploadService;